import React, { useEffect, useState } from "react";
import OutsidePickModal from "./OutisdePickModal";
export default function OutsideInput(props) {
  const {
    value,
    onChange,
    source,
    reclimit,
    pickField = "id",
    uncontrolled = false,
  } = props;
  const [modalShow, changeModalVisible] = useState(false);
  const [inputValue, changeInputValue] = useState(value);

  const onInputChange = (e) => {
    if (uncontrolled) {
      changeInputValue(e.target.value);
    } else {
      onChange(e.target.value);
    }
  };

  const onInputBlur = () => {
    if (uncontrolled) {
      if (inputValue !== value) {
        onChange(inputValue);
      }
    }
  };

  useEffect(() => {
    if (uncontrolled) {
      changeInputValue(props.value);
    }
  }, [props.value, uncontrolled, value]);

  return (
    <React.Fragment>
      <OutsidePickModal
        onClose={() => changeModalVisible(false)}
        onPick={(item) => onChange(item[pickField])}
        source={source}
        show={modalShow}
        reclimit={reclimit}
      />
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          value={uncontrolled ? inputValue : value}
          onChange={onInputChange}
          onBlur={onInputBlur}
          onDoubleClick={() => changeModalVisible(true)}
        />
        <div className="input-group-append">
          <button
            title="Выбрать"
            className="btn btn-icon border"
            type="button"
            onClick={() => changeModalVisible(true)}
          >
            <i className="fa icon-md text-muted fa-search"></i>
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
